import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgLink = function SvgLink(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 25 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M13.167 14.905a1 1 0 00-.543 1.307 1 1 0 01-.217 1.09l-2.828 2.829a2 2 0 01-2.828 0L4.629 18.01a2 2 0 010-2.829l2.832-2.828a1.013 1.013 0 011.09-.217 1 1 0 10.764-1.849 3.034 3.034 0 00-3.268.652l-2.832 2.828a4.006 4.006 0 000 5.657l2.122 2.121a4 4 0 005.656 0l2.829-2.828a3.008 3.008 0 00.65-3.27 1 1 0 00-1.305-.542z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M8.517 16.241a1.011 1.011 0 001.414 0l7.78-7.778a1 1 0 00-1.415-1.414l-7.779 7.778a1 1 0 000 1.414z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M22.306 4.574l-2.12-2.12a4.006 4.006 0 00-5.658 0L11.7 5.28a3.006 3.006 0 00-.65 3.27 1 1 0 101.848-.765 1 1 0 01.217-1.086l2.828-2.828a2 2 0 012.83 0l2.12 2.121a2 2 0 010 2.83l-2.832 2.822a1.015 1.015 0 01-1.09.217 1 1 0 00-.766 1.85 3.026 3.026 0 003.27-.652l2.828-2.828a4.007 4.007 0 00.004-5.658z"
  }));
};

export default SvgLink;